import {IComponentController, IComponentOptions} from "angular";
import {ACTION_SERVICE_NAME, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {ActionService} from "../../../opportunity_actions_service/service/ActionService";
import {Customer} from "../../../customers/model/Customer";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {OpportunityAction} from "../../../opportunity_actions/model/OpportunityAction";
import './customer-activity.component.scss';

export class CustomerActivityComponent implements IComponentController {

    public static instance: IComponentOptions = {
        controller: [ACTION_SERVICE_NAME, ToastNotificationServiceName, CustomerActivityComponent],
        template: require('./customer-activity.component.html'),
        bindings: {
            customer: '<'
        }
    };

    private customer: Customer;
    private actions: OpportunityAction[];

    constructor(private actionService: ActionService,
                private toastNotificationService: ToastNotificationService) {
    }

    $onInit(): void {
        this.fetchCustomerActions();
    }

    private fetchCustomerActions() {
        this.actionService.findCustomerActions(this.customer.id)
            .then((oppActionsResp) => {
                    if (oppActionsResp.status == 200) {
                        this.actions = oppActionsResp.data;
                    } else {
                        this.notifyActionsFetchFailed();
                    }
                },
                (err) => {
                    this.notifyActionsFetchFailed();
                })
    }

    private notifyActionsFetchFailed() {
        this.toastNotificationService.generateErrorMessage("Failed to fetch customer actions!")
    }
}